var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "categoryProductslist" },
    [
      _c("div", [
        _vm.FilterCriteria.length > 0
          ? _c("div", { staticClass: "title" }, [
              _vm.hideshow
                ? _c(
                    "div",
                    { staticClass: "title-query" },
                    _vm._l(_vm.FilterCriteria, function (fItem, fIndex) {
                      return _c(
                        "div",
                        { key: fIndex, staticClass: "title-query-body" },
                        [
                          _c("div", { staticClass: "title-query-body-left" }, [
                            _vm._v(_vm._s(fItem.field_key)),
                          ]),
                          _vm.selectshow != fItem.field_key
                            ? _c(
                                "div",
                                { staticClass: "title-query-body-cnt" },
                                _vm._l(fItem.show_map, function (item) {
                                  return _c(
                                    "el-button",
                                    {
                                      key: item,
                                      class: fItem.value.includes(item)
                                        ? ""
                                        : "btnclass",
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.chooseItem(item, fIndex)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(item) + " ")]
                                  )
                                }),
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "title-query-body-cnt" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: fItem.value,
                                            callback: function ($$v) {
                                              _vm.$set(fItem, "value", $$v)
                                            },
                                            expression: "fItem.value",
                                          },
                                        },
                                        _vm._l(
                                          fItem.field_map,
                                          function (item) {
                                            return _c("el-checkbox", {
                                              key: item,
                                              attrs: { label: item },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-top": "20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectqx(
                                                fItem.field_key,
                                                fIndex
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("取消")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectqd(
                                                fItem.field_key,
                                                fIndex
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("确定")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                          _c(
                            "div",
                            { staticClass: "title-query-body-right" },
                            [
                              fItem.field_map.length > 12
                                ? _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.morelist(fItem.field_key)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.duoshow == fItem.field_key
                                            ? "收起"
                                            : "更多"
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectlist(
                                        fItem.field_key,
                                        fIndex,
                                        fItem
                                      )
                                    },
                                  },
                                },
                                [_vm._v("多选")]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _c("div", { staticClass: "title-query-btn" }, [
          _c(
            "div",
            { staticClass: "title-query-btn-left d-flex a-center" },
            [
              _vm._l(_vm.taglist, function (item) {
                return _c(
                  "el-button",
                  {
                    key: item.id,
                    attrs: {
                      type: _vm.fromcopy.audit_type == item.id ? "primary" : "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.tagquery(item)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(item.name) +
                        "(" +
                        _vm._s(_vm.tagnum[item.num]) +
                        ")"
                    ),
                  ]
                )
              }),
              _c(
                "div",
                {
                  staticClass: "d-flex a-center goodsName",
                  staticStyle: { width: "150px" },
                },
                [
                  _c("span", [_vm._v("商品名称：")]),
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.fromcopy.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.fromcopy, "title", $$v)
                      },
                      expression: "fromcopy.title",
                    },
                  }),
                ],
                1
              ),
              _vm.fromcopy.audit_type == 2
                ? _c(
                    "div",
                    { staticClass: "d-flex a-center goodsName" },
                    [
                      _c("span", { staticStyle: { width: "100px" } }, [
                        _vm._v("审核状态:"),
                      ]),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选审核状态",
                          },
                          model: {
                            value: _vm.audit_type_1,
                            callback: function ($$v) {
                              _vm.audit_type_1 = $$v
                            },
                            expression: "audit_type_1",
                          },
                        },
                        _vm._l(_vm.list104, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.fromcopy.audit_type == 3
                ? _c(
                    "div",
                    { staticClass: "d-flex a-center goodsName" },
                    [
                      _c("span", { staticStyle: { width: "100px" } }, [
                        _vm._v("审核状态:"),
                      ]),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选审核状态",
                          },
                          model: {
                            value: _vm.audit_type_1,
                            callback: function ($$v) {
                              _vm.audit_type_1 = $$v
                            },
                            expression: "audit_type_1",
                          },
                        },
                        _vm._l(_vm.list106, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.fromcopy.audit_type == 4
                ? _c(
                    "div",
                    { staticClass: "d-flex a-center goodsName" },
                    [
                      _c("span", { staticStyle: { width: "100px" } }, [
                        _vm._v("审核状态:"),
                      ]),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选审核状态",
                          },
                          model: {
                            value: _vm.audit_type_1,
                            callback: function ($$v) {
                              _vm.audit_type_1 = $$v
                            },
                            expression: "audit_type_1",
                          },
                        },
                        _vm._l(_vm.list105, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "title-query-btn-right" },
            [
              _c("el-button", { on: { click: _vm.drawerclcik } }, [
                _vm._v("表头排序"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.querylist } },
                [_vm._v("刷新")]
              ),
              _c(
                "span",
                { staticClass: "mr10", staticStyle: { color: "red" } },
                [_vm._v("坑位：" + _vm._s(_vm.slot) + "个")]
              ),
              _vm.FilterCriteria.length > 0
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-s-fold", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.hideshow = !_vm.hideshow
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.hideshow ? "隐藏" : "展开"))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.disabledExport },
                  on: { click: _vm.onHandleExport },
                },
                [_vm._v("导出")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.querylist } },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh-right" },
                  on: { click: _vm.Reset },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "title-query-item" },
          _vm._l(_vm.tag_list, function (item, index) {
            return _c(
              "el-tag",
              {
                key: index,
                attrs: { closable: "" },
                on: {
                  close: function ($event) {
                    return _vm.close(item, index)
                  },
                },
              },
              [_vm._v(_vm._s(item.name))]
            )
          }),
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c(
                "div",
                [
                  _vm._l(_vm.sort_list, function (item, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        item.value == "kv"
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "kv",
                                align: "center",
                                label: item.label,
                                "min-width": item["min-width"],
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "imgs",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onHandelDetails(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "img-box",
                                              attrs: {
                                                src: scope.row.kv,
                                                alt: "",
                                              },
                                            }),
                                            scope.row.kv_last_time
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.timename(
                                                        scope.row.kv_last_time
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : item.value == "title"
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "title",
                                align: "center",
                                label: item.label,
                                "min-width": item["min-width"],
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onHandelDetails(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(scope.row.title))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _c("el-table-column", {
                              attrs: {
                                prop: item.value,
                                align: "center",
                                label: item.label,
                                "min-width": item["min-width"],
                              },
                            }),
                      ],
                      1
                    )
                  }),
                  _c(
                    "div",
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          align: "center",
                          "min-width": "150",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.operate_btn == 1
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.down(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("下架")]
                                    )
                                  : _vm._e(),
                                scope.row.operate_btn == 2
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.adopt(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("通过")]
                                    )
                                  : _vm._e(),
                                scope.row.operate_btn == 2
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "danger", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.reject(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("驳回")]
                                    )
                                  : _vm._e(),
                                scope.row.audit_type == 5
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "danger", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.takedown(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("下架原因")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "audit_status_txt",
                          align: "center",
                          label: "审核状态",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.audit_status_txt)
                                        ),
                                      ]
                                    ),
                                    scope.row.buyer
                                      ? _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.buyer.fullname) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "price",
                          align: "center",
                          label: "开市价",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "title-item" }, [
                                  _c("div", [_vm._v("开市价")]),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "weight_price",
                          align: "center",
                          label: "净单价",
                          "min-width": "100",
                          fixed: "right",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "percent_rate",
                          fixed: "right",
                          align: "center",
                          label: "售后率",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "repurchase_30",
                          fixed: "right",
                          align: "center",
                          label: "复购率",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.from.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.from.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm.centerDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title: "是否驳回",
                visible: _vm.centerDialogVisible,
                width: "500px",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.centerDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "contents" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "驳回原因", prop: "reason" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "302px" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  placeholder: "请输入内容",
                                  maxlength: "200",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.ruleForm.reason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "reason", $$v)
                                  },
                                  expression: "ruleForm.reason",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "图片上传" } },
                        [
                          _c("b-file-upload", {
                            key: "reject_img",
                            attrs: {
                              accepts: ["jpg", "jpeg", "png"],
                              limit: 4,
                            },
                            model: {
                              value: _vm.detailPicList,
                              callback: function ($$v) {
                                _vm.detailPicList = $$v
                              },
                              expression: "detailPicList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.ruleFormqr },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("GoodsDetails", { ref: "GoodsDetailsref" }),
      _c("dialogtable", { ref: "dialogtableref" }),
      _c("belowdialog", {
        ref: "belowdialogref",
        on: { successbelow: _vm.successbelow },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "品类排序",
            visible: _vm.drawer,
            direction: "rtl",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    "margin-bottom": "20px",
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "draggableTable",
                  attrs: {
                    data: _vm.tableDatasorst,
                    "row-key": "label",
                    stripe: "",
                    height: "100%",
                    border: true,
                    "header-cell-style": {
                      color: "#333333",
                      background: "#EFF6FF",
                    },
                  },
                  on: { "row-dragged": _vm.handleRowDragged },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      width: "100",
                      align: "center",
                      label: "序号",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "label", label: "名称", align: "center" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "item.prop",
                      align: "center",
                      label: "操作",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("i", { staticClass: "el-icon-rank" })]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }